// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

const HeaderView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "HeaderView" */ '../views/Header.view'
  )
);

const NewHeaderView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "NewHeaderView" */ '../views/HeaderNew.view'
  )
);

const HeaderNewDesignView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "HeaderNewDesignView" */ '../views/HeaderNewDesign.view'
  )
);

const HeaderWrapper = (props) => {
  const { isGlobalHeaderRedesignEnabled, isGlobalDefaultHeaderRedesignEnabled } = props;

  if (isGlobalDefaultHeaderRedesignEnabled) {
    return <HeaderNewDesignView {...props} />;
  }

  if (!isGlobalHeaderRedesignEnabled) {
    return <HeaderView {...props} />;
  }
  return <NewHeaderView {...props} />;
};

HeaderWrapper.propTypes = {
  isGlobalHeaderRedesignEnabled: PropTypes.bool,
  isGlobalDefaultHeaderRedesignEnabled: PropTypes.bool,
};

HeaderWrapper.defaultProps = {
  isGlobalHeaderRedesignEnabled: false,
  isGlobalDefaultHeaderRedesignEnabled: false,
};

export default HeaderWrapper;
export { HeaderWrapper as HeaderWrapperVanilla };
